import React, { FC } from 'react';
import Text from '../Text';
import View from '../View';
import { TextProps } from '../Text/component';
import styles from './styles';

type HeaderProps = {
  title?: string;
};

type HeaderCombinedProps = TextProps & HeaderProps;

export const HeaderTwo: FC<HeaderCombinedProps> = (props) => {
  const { title = '' } = props;
  return (
    <View style={styles.container}>
      <Text
        accessibilityRole="header"
        {...props}
        style={[styles.text, props.style]}
      >
        {title}
      </Text>
    </View>
  );
};

export default HeaderTwo;
